import React, { Component } from 'react';
import { Row, Field, Label }  from '../../generic';
import TextInput from '../../generic/fields/TextInput';
import styled from 'styled-components';

const LogoImage = styled.img`
  opacity: 1; 
  max-width: 150px; 
  max-height: 150px; 
  margin-top: 10px;
`

class Signature extends Component {
  render() {
    const { userEvent, onChange } = this.props
    return (
      <React.Fragment>
        { userEvent.signature }
        { userEvent.invitation_logo ? <div><LogoImage className="invitation-logo" src={userEvent.invitation_logo} /></div> : '' }
      </React.Fragment>
    )
  }
}

export default Signature
